import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const DocumentBulkAccountCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { selectedDocumentCount = 0, documentBulkAccountOptions = [] } =
        options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set account for ${selectedDocumentCount} ${pluralize("document", selectedDocumentCount)}`}
            options={documentBulkAccountOptions}
        />
    );
};
